Librarian.ModuleLoader = new Class({
    Implements: [Options, Events], 
    Binds: ["loadModules", "loadModule"],

    options: {
        container: null,
        defaultHeight: 200
    },

    containerEl: null,

    modules: {},

    initialize: function(options) {
        this.setOptions(options);

        if (!this.options.container)
            return;

        this.containerEl = $(this.options.container);
    },

    destroy: function() {
        for (var key in this.modules) {
            if (!this.modules.hasOwnProperty(key) || !this.modules[key])
                continue;

            this.modules[key].destroy();
        }

        this.modules = {};

        if (this.containerEl) {
            this.containerEl.empty();
            this.containerEl.removeClass("pure-g-r");
        }
    },

    loadModules: function(moduleList, containerEl, idSuffix) {
        if ((typeof moduleList == "undefined") || (moduleList == null) || (moduleList.length == 0))
            return;
        if (!containerEl)
            containerEl = this.containerEl;
        if (!this.containerEl)
            return;
        if ((typeof idSuffix == "undefined") || (idSuffix == null))
            idSuffix = '';

        containerEl.empty();
        containerEl.addClass("pure-g-r");

        // Go through each row in the modules list
        for (var i = 0; i < moduleList.length; i++) {
            // If this doesn't have any modules in it, skip it
            if (moduleList[i].modules == null || (moduleList[i].modules.length == 0))
                continue;

            var height = moduleList[i].height;
            if (typeof height == "string" && height.endsWith("%")) {
                var mainEl = $("mainPanel"),
                    percentage = parseInt(height),
                    parentHeight = mainEl.getHeight();

                height = parentHeight * (percentage / 100);
            }

            // Get the height of the row, either from the definition or the default
            var rowHeight = height || this.options.defaultHeight,
                minHeight = moduleList[i].minHeight,
                modules = moduleList[i].modules,
                colCount = moduleList[i].colCount || modules.length,
                rowCount = moduleList[i].rowCount || 1,
                extraClass = moduleList[i].className || '',
                rowEl = new Element("div", {
                    "class": "modules-row " + extraClass,
                    "id": "modules-row-" + (i + 1) + idSuffix
                }).injectInside(containerEl);

            // Go through each module in this row
            for (var j = 0; j < modules.length; j++) {
                if (!modules[j])
                    continue;

                // Get the container element in the right auto-created column
                var moduleEl = this.getModuleEl(modules[j], colCount, rowEl);
                // Create the module and all sub-modules
                this.createModule(modules[j], moduleEl, rowHeight, rowCount, minHeight);
            }
        }
    },

    getModuleEl: function(module, colCount, contEl) {
        var colSpan = module.colSpan || 1,
            colTotal = colCount;

        // Pure grids use simple fractions
        var fraction = this.reduceFraction(colSpan, colTotal),
            numerator = fraction[0],
            denominator = fraction[1];

        var pureClass = "pure-u-" + numerator;
        if (denominator > 1)
            pureClass += "-" + denominator;

        // Create a container element
        var colEl = new Element("div", { "class": pureClass }).injectInside(contEl),
            moduleEl = new Element("div", { "class": "modules-module" }).injectInside(colEl);

        return moduleEl;
    },

    // http://stackoverflow.com/a/4652513
    reduceFraction: function(numerator, denominator) {
        var gcd = function(a, b) {
            return b ? gcd(b, a % b) : a;
        };

        gcd = gcd(numerator, denominator);

        return [numerator / gcd, denominator / gcd];
    },

    getModuleHeight: function(module, rowHeight, rowCount, margin) {
        if (typeof rowHeight != "number")
            return rowHeight;

        var modHeight = rowHeight,
            rowSpan = module.rowSpan || 1;
        if (typeOf(module.modules) == "array")
            rowSpan = module.modules.length;

        modHeight *= (rowSpan / rowCount);

        // Adjust the height by a factor of the number of rows and the margin
        var adjustment = ((rowCount - 1) / rowCount) * margin;
        return (modHeight - (rowSpan * adjustment)) + (margin * (rowSpan - 1));
    },

    createModule: function(module, moduleEl, rowHeight, rowCount, minHeight, isHorizontal, bottomMargin) {
        if (!module)
            return;

        // If there is a sub module array
        if (typeOf(module.modules) == "array") {
            // Go through each sub module
            var subModules = module.modules,
                marginBottom = 0;
            for (var k = 0; k < subModules.length; k++) {
                if (isHorizontal) {
                    moduleEl.addClass("pure-g-r");
                    var colModEl = this.getModuleEl(subModules[k], subModules.length, moduleEl);
                    this.createModule(subModules[k], colModEl, rowHeight, rowCount, minHeight, false, bottomMargin);
                }
                else {
                    var subModuleEl = new Element("div", {
                            "class": "modules-submodule"
                        }).injectInside(moduleEl),
                        self = this;

                    // Timeout allows DOM to apply styles to the element so the marginBottom value is correct
                    setTimeout(function(subModule, el) {
                        // Save the bottom margin of the first item because the last one won't have a margin
                        if (marginBottom == 0)
                            marginBottom = el.getStyle("marginBottom").toInt() || 0;

                        // Check if this module has any sub-modules and load that
                        self.createModule(subModule, el, rowHeight, rowCount, minHeight, true, marginBottom);
                    }.pass([subModules[k], subModuleEl]), 100);
                }
            }
        }
        // Load the module
        else {
            var modHeight = this.getModuleHeight(module, rowHeight, rowCount, bottomMargin || 0);
            this.loadModule(module, modHeight, minHeight, moduleEl, true);
        }
    },

    loadModule: function(moduleInfo, height, minHeight, contEl, destroyWrapper) {
        var options = Object.merge({
            height: height,
            minHeight: minHeight,
            id: moduleInfo.id
        }, moduleInfo.options);

        // Explicitly check the title so that if the module defines a default title we don't override it with nothing
        if ((typeof moduleInfo.title == "string") || (typeOf(moduleInfo.title) == "object"))
            options.title = moduleInfo.title;

        if (moduleInfo.type == "skip")
            return;

        var module = new Librarian.Modules[moduleInfo.type](options, contEl, destroyWrapper);
        module.load();
        this.modules[moduleInfo.id] = module;
    },

    getModule: function(key) {
        return this.modules[key];
    },

    callModuleFunction: function(func) {
        for (var moduleName in this.modules) {
            if (!this.modules.hasOwnProperty(moduleName))
                continue;

            var module = this.modules[moduleName];
            if (!module || (typeof module[func] != "function"))
                continue;

            module[func]();
        }
    }
});

Librarian.ModuleLoaders = {};
Librarian.Modules = {};
